import React from 'react';
import { Button, ConfigProvider, theme } from 'antd';
import PropTypes from 'prop-types';
import { intents } from '../utils';

const { useToken } = theme;

const getButtonStyle = (intent, palette) => {
  switch (intent) {
    case intents.primary:
      return {
        colorLink: palette.acastPurpleActive,
        colorLinkHover: palette.acastPurpleFocus,
        colorLinkActive: palette.acastPurpleFocus,
      };

    case intents.warning:
      return {
        colorLink: palette.acastOrangeAccent,
        colorLinkHover: palette.acastOrange,
        colorLinkActive: palette.acastOrange,
      };

    default:
      return {
        colorLink: palette.acastBlackDefault,
        colorLinkHover: palette.acastBlackFocus,
        colorLinkActive: palette.acastBlackFocus,
      };
  }
};

const TextButton = ({ intent, text, link, onClick, disabled, busy, style = {} }) => {
  const {
    token: { acastPalette: palette },
  } = useToken();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            ...getButtonStyle(intent, palette),
            paddingInline: '0',
            paddingBlock: '0',
          },
        },
      }}
    >
      <Button
        // text button has paddings and background in antd for some reason while we want it to have no padding and background
        type="link"
        href={link}
        onClick={onClick}
        disabled={disabled}
        loading={busy}
        style={style}
      >
        {text}
      </Button>
    </ConfigProvider>
  );
};

TextButton.propTypes = {
  intent: PropTypes.oneOf(Object.values(intents)),
  text: PropTypes.node.isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  busy: PropTypes.bool,
  style: PropTypes.object,
};

export default TextButton;
